"use client";

import { SmartLink } from "@/Components";
import { Theme } from "@/Enums";
import { useAccount, useAppSetting } from "@/Hooks";
import { FC, MouseEvent } from "react";

export type DarkModeToggleMode = "standard" | "inverted";

interface DarkModeToggleProps {
  mode?: DarkModeToggleMode;
  withWrapper?: boolean;
}

const DarkModeToggle: FC<DarkModeToggleProps> = ({
  mode = "standard",
  withWrapper = false,
}) => {
  const appSetting = useAppSetting();
  const { reloadProfile } = useAccount();
  const isDarkMode = appSetting.theme === Theme.Dark;
  const isStandardMode = mode === "standard";

  const darkToggleActive = isStandardMode ? isDarkMode : !isDarkMode;
  const lightToggleActive = !darkToggleActive;

  const onToggle = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    appSetting.toggleTheme();
    reloadProfile();
  };

  const content = (
    <>
      <SmartLink
        href="#"
        id="dark-mode-toggle"
        className={`theme-toggle ${darkToggleActive ? "activate" : ""}`.trim()}
        onClick={onToggle}
      >
        <i className="isax isax-sun-1" />
      </SmartLink>
      <SmartLink
        href="#"
        id="light-mode-toggle"
        className={`theme-toggle ${lightToggleActive ? "activate" : ""}`.trim()}
        onClick={onToggle}
      >
        <i className="isax isax-moon" />
      </SmartLink>
    </>
  );

  if (withWrapper) {
    return (
      <div className="header-theme header-theme-two">
        <div className="header-theme header-theme-two">{content}</div>
      </div>
    );
  }

  return content;
};

export default DarkModeToggle;
